<div [ngModelGroup]="panelId">
    @if (doneLoading) {
    <div>
        @for (row of rowArray; track trackByRow($index, row)) {
        <div fxLayout="row" fxLayoutAlign="space-evenly start" class="tt-padding-bottom-sm"
            [ngStyle]="{ 'padding-right' : getSummaryPadding() }">
            @for (metadataIntermediary of row.Intermediaries; track trackByProperty($index, metadataIntermediary)) {
            <div [fxFlex]="getWidth(metadataIntermediary)" class="edit-field">
                @if (!!metadataIntermediary.property.SummaryType) {
                <metadata-input [viewOnly]="true" [field]="metadataIntermediary.name"
                    [metadata]="metadataIntermediary.metadata" [metadataModel]="metadataIntermediary.model"
                    disabled="true" [parent]="metadataIntermediary.parent"
                    (modifierCallback)="doMetadataModifier($event)" [datacontroller]="datacontroller">
                </metadata-input>
                }
            </div>
            }
        </div>
        }
    </div>
    }
</div>